import { Component } from '@angular/core';

@Component({
  selector: 'app-sed-events-predictive-maintenance',
  templateUrl: './sed-events-predictive-maintenance.component.html',
  styleUrl: './sed-events-predictive-maintenance.component.scss',
  standalone: false,
})
export class SedEventsPredictiveMaintenanceComponent {}
